module.exports = __webpack_public_path__ + "vue2-dropzone1.png?93d2bf4221b4c9873561d5644497b414";